import {
  useJWTAuth,
  useJWTAuthActions,
} from "../services/auth/jwt/JwtAuthProvider";

export const useAuthUser = () => {
  const { user, isAuthenticated, isLoading } = useJWTAuth();

  return {
    isLoading,
    isAuthenticated,
    user,
  };
};

export const useAuthMethod = () => {
  const { signInUser, logout } = useJWTAuthActions();

  return {
    signInUser,
    logout,
  };
};
